import { TimePicker } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export const TimePickerControlled = ({ name, placeholder }) => {
  const { control } = useFormContext();

  return (
    <Controller
      render={({ field: { onChange, value = null } }) => (
        <LocalizationProvider dateAdapter={DateAdapter}>
          <TimePicker
            renderInput={(props) => <TextField {...props} label={placeholder} size="small" />}
            value={value}
            onChange={onChange}
          />
        </LocalizationProvider>
      )}
      control={control}
      name={name}
    />
  );
};
